import { render, staticRenderFns } from "./button-back.vue?vue&type=template&id=6816cd87"
import script from "./button-back.vue?vue&type=script&lang=js"
export * from "./button-back.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports